module.exports = __webpack_public_path__ + "static/media/comm.f1fe9aeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/comm.jpg
// module id = 293
// module chunks = 0